<template>
  <div class="mission-asset-metrics">
    <v-row>
      <v-col>
        <v-btn
          color="success"
          block
          height="100%"
          class="py-2"
          @click="onMetricClick('passed')"
        >
          <div class="d-flex flex-column">
            <div>{{ metrics.passed_percentage || 0 }}%</div>
            <div>
              [{{ metrics.passed_count || 0 }}/{{
                metrics.passed_total_count || 0
              }}]
            </div>
            <div>{{ getTerminology("passed") || "PASSED" }}</div>
          </div>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          color="error"
          block
          height="100%"
          class="py-2"
          @click="onMetricClick('failed')"
        >
          <div class="d-flex flex-column">
            <div>{{ metrics.failed_percentage || 0 }}%</div>
            <div>
              [{{ metrics.failed_count || 0 }}/{{
                metrics.failed_total_count || 0
              }}]
            </div>
            <div>{{ getTerminology("failed") || "FAILED" }}</div>
          </div>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          color="warning"
          block
          height="100%"
          class="py-2"
          @click="onMetricClick('faults-identified')"
        >
          <div class="d-flex flex-column">
            <div>{{ metrics.faults_identified_count || 0 }}</div>
            <div>FAULTS</div>
            <div>IDENTIFIED</div>
          </div>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          color="warning"
          block
          height="100%"
          class="py-2"
          @click="onMetricClick('inspections-overdue')"
        >
          <div class="d-flex flex-column">
            <div>{{ metrics.inspections_overdue_count || 0 }}</div>
            <div>INSPECTIONS</div>
            <div>OVERDUE</div>
          </div>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          color="primary"
          block
          height="100%"
          class="py-2"
          @click="onMetricClick('new-assets')"
        >
          <div class="d-flex flex-column">
            <div>{{ metrics.new_assets_count || 0 }}</div>
            <div>NEW</div>
            <div>ASSETS</div>
          </div>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          color="primary"
          block
          height="100%"
          class="py-2"
          @click="onMetricClick('inspected-ytd')"
        >
          <div class="d-flex flex-column">
            <div>{{ metrics.inspected_ytd_percentage || 0 }}%</div>
            <div>
              [{{ metrics.inspected_ytd_count || 0 }}/{{
                metrics.inspected_ytd_total_count || 0
              }}]
            </div>
            <div>INSPECTED YTD</div>
          </div>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash/lodash";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import { MissionAssetService } from "@/services/missionAsset.service";

export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    metrics: {},
    loading: false,
    metric_previous: null,
    date_start_previous: null,
    date_end_previous: null,
  }),
  computed: {
    ...mapGetters("config", ["getTerminology"]),
    relevantFilters() {
      return this.$store.state.filters.missions;
    },
    queryParams() {
      if (this.params && Object.keys(this.params).length > 0) {
        return this.params;
      }
      return this.queryParamsFromStoreFilters;
    },
    queryParamsFromStoreFilters() {
      let missionFilters = this.$store.state.filters.missions;
      let params = {
        number: missionFilters.number,
        region: missionFilters.region,
        third_party_code: missionFilters.reference,
        status: missionFilters.status,
        inspected_by: missionFilters.inspectedBy,
        include_archived: missionFilters.includeArchived,
        claimed: missionFilters.claimed,
        locked: missionFilters.locked,
        // From mission_assets filters
        mission_id: missionFilters.mission,
        faults: missionFilters.faults,
        is_failed: missionFilters.serviceFailed,
        is_cleaned: missionFilters.serviceSuccessful,
        is_new_asset: missionFilters.newAsset,
        service_type: missionFilters.serviceType,
        assessment_period_end: missionFilters.dateEnd,
        assessment_period_start: missionFilters.dateStart,
      };
      params = _.pickBy(params, value => {
        return ( ! _.isUndefined(value));
      });
      return params;
    }
  },
  watch: {
    "$store.state.missions.recently_updated": function(recently_updated) {
      this.fetchMetrics();
    },
    relevantFilters() {
      this.fetchMetrics();
    }
  },
  mounted() {
    // this.fetchMetrics();
  },
  methods: {
    async fetchMetrics() {
      try {
        this.loading = true;

        const metrics = await MissionAssetService.metrics({
          ...this.queryParams,
          timezone: moment.tz.guess(),
        }).then((response) => response.data);

        this.metrics = metrics;
      } catch (err) {
        console.error(err);
        throw err;
      } finally {
        this.loading = false;
      }
    },
    onMetricClick(metric) {

      this.$emit('click-metric', metric);

      // We usually want to keep only the current date range
      // and then add filters for the metric in question.
      let nextFilters = _.pickBy(this.$store.state.filters.missions, (item, key) => {
        return (['dateStart', 'dateEnd'].indexOf(key) >= 0);
      });

      switch (metric) {
        case 'passed':
          nextFilters = Object.assign({}, nextFilters, {
            serviceSuccessful: true,
            serviceFailed: false,
          });
          this.$store.dispatch('filters/setMissionsFilters', nextFilters);
          break;
        case 'failed':
          nextFilters = Object.assign({}, nextFilters, {
            serviceSuccessful: false,
            serviceFailed: true,
          });
          this.$store.dispatch('filters/setMissionsFilters', nextFilters);
          break;
        case 'faults-identified':
          nextFilters = Object.assign({}, nextFilters, {
            faults: ['resolved', 'unresolved']
          });
          this.$store.dispatch('filters/setMissionsFilters', nextFilters);
          break;
        case 'inspections-overdue':
          nextFilters = Object.assign({}, nextFilters, {
            serviceType: 'serviceOverdue',
            dateEnd: moment().subtract(6, "months").format("YYYY-MM-DD"),
            dateStart: ""
          });
          this.$store.dispatch('filters/setMissionsFilters', nextFilters);
          break;
        case 'new-assets':
          nextFilters = Object.assign({}, nextFilters, {
            newAsset: true
          });
          this.$store.dispatch('filters/setMissionsFilters', nextFilters);
          break;
        case 'inspected-ytd':
          nextFilters = Object.assign({}, nextFilters, {
            dateEnd: moment().format("YYYY-MM-DD"),
            dateStart: this.$store.state.filters.missionsAssessmentPeriod.fy_start
          });
          this.$store.dispatch('filters/setMissionsFilters', nextFilters);
          break;
      }
    }
  },
};
</script>